"use strict";
var $ = require("../internals/export");
var getBuiltIn = require("../internals/get-built-in");
var anObject = require("../internals/an-object");
var FREEZING = require("../internals/freezing");
$({ target: "Reflect", stat: true, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      var objectPreventExtensions = getBuiltIn("Object", "preventExtensions");
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});
